class DocumentConsentController {
  constructor ($window, I18n, $scope, $rootScope, DocumentsService) {
    'ngInject'
    this.$window = $window
    this.I18n = I18n
    this.$scope = $scope
    this.$rootScope = $rootScope
    // show variable is just for cosmetic, without that the popup would be displayed on login and hidden after page load
    this.show = false
    this.documentsService = DocumentsService
    this.documentsService.getUntreatedDocuments().then(result => {
      this.documents = result
      console.log(this.documents)
      if (this.documents.length !== 0) {
        this.show = true
      } else {
        this.show = false
        this.$rootScope.$broadcast('checkDocumentConsent:off')
      }
    }).catch(() => {
      this.documents = []
      this.show = false
    })
  }

  get consent () {
    return this.show
  }

  disableConsent () {
    this.$rootScope.$broadcast('checkDocumentConsent:off')
  }

  validateConsents () {
    var idToVcalidate = []
    for (var document of this.documents) {
      idToVcalidate.push(document.id)
    }
    this.documentsService.sendDocumentConsent(idToVcalidate)
    this.$rootScope.$broadcast('checkDocumentConsent:off')
  }

  makeName (document) {
    var prefix
    switch (document.type) {
      case 'EULA':
        prefix = 'legalInformation'
        break
      case 'GTC':
        prefix = 'generalTermsAndConditions'
        break
      case 'WITHDRAWAL':
        prefix = 'withdrawalRights'
        break
      default :
        prefix = 'UNKNOWN'
    }
    var documentName = prefix +
      '_' + document.country +
      '_' + this.I18n.getLanguage() +
      '_latest.pdf'

    return documentName
  }

  makeLink (document) {
    var path
    var prefix
    switch (document.type) {
      case 'EULA':
        prefix = 'legalInformation'
        path = 'pdf/published-pdf/EULA/'
        break
      case 'GTC':
        prefix = 'generalTermsAndConditions'
        path = 'pdf/published-pdf/GTC/'
        break
      case 'WITHDRAWAL':
        prefix = 'withdrawalRights'
        path = 'pdf/published-pdf/WITHDRAWAL/'
        break
      default :
        prefix = 'UNKNOWN'
        path = '/'
    }
    var documentName = path +
      prefix +
      '_' + document.country +
      '_' + this.I18n.getLanguage() +
      '_latest.pdf'

    return documentName
  }
}

export default DocumentConsentController



// WEBPACK FOOTER //
// ./src/app/common/document-consent/document-consent.controller.js